import {
  supplierProductState
} from "./supplierProduct.state";
import {
  supplierProductActions
} from "./supplierProduct.actions";
import {
  supplierProductGetters
} from "./supplierProduct.getters";
import {
  supplierProductMutations
} from "./supplierProduct.mutations";

export default {
  state: supplierProductState,
  actions: supplierProductActions,
  getters: supplierProductGetters,
  mutations: supplierProductMutations
};